import { AddUsersComponent } from './add-users/add-users.component';
import { ViewInformationUsersComponent } from './view-users/view-users.component';
import { EditUsersComponent } from './edit-users/edit-users.component';

export const UsersDeclaration = [
   ViewInformationUsersComponent,
   AddUsersComponent,
   EditUsersComponent

];
